// extracted by mini-css-extract-plugin
export default {"MainCheckbox":"InputCheckbox_MainCheckbox__c620D"};